import React, { Component } from "react";
import Link from "next/link";
import moment from "moment";
import { baseUrl } from "./../../config/config";

class EventCard extends Component {
	constructor(props) {
		super(props);
	}

	/******IMPORTANT******
        The tbale is not responsive, coz of fixed images width
        The date needs to be changed to the correct format,a s shown in cards
    ********************/

	render() {
		return (
			<>
				<div className="events-table-container d-flex p-2 m-3 flex-column flex-grow-1">
					<table className="table table-hover table-responsive">
						<thead>
							<tr>
								<th scope="col">Event Poster</th>
								<th scope="col">Event Name</th>
								<th scope="col">Event Dates</th>
								<th scope="col">Ticket Type</th>
							</tr>
						</thead>
						<tbody>
							{this.props.data.map(event => (
								<tr>
									<th scope="row">
										<img
											src={event.event_poster_url}
											width={"auto"}
											height={50}
											alt={event.name}
										/>
									</th>
									<td>
										<a
											href={event.event_url}
											style={{ cursor: "pointer" }}
											target="_blank"
											target="noreferrer"
										>
											{event.name}
										</a>
									</td>
									<td>
										<i className="fas fa-calendar" />
										&nbsp;
										{moment(this.props.data.start_date).format("MMM Do 'YY")}
										&nbsp;-&nbsp;
										{moment(this.props.data.end_date).format("MMM Do 'YY")}
										{/*{moment(`${event.start_date} ${event.start_time}`).format('LT')} IST*/}
									</td>
									<td>
										<i className="fas fa-ticket-alt" />
										&nbsp;
										{event.is_free ? "Free" : "Paid"}
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
				<style jsx>{`
					td {
						vertical-align: middle;
					}
				`}</style>
			</>
		);
	}
}

export default EventCard;
